import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

export type BreadCrumbLink = {
  label: string;
  href: string;
};

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent implements OnInit {
  @Input() links: BreadCrumbLink[];

  constructor(private router: Router) {}

  ngOnInit() {}

  navigateTo(url: string | undefined): void {
    if (url) {
      this.router.navigate([url]);
    }
  }
}
